var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDiagRightUp = function SvgArrowDiagRightUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "arrow-diag-right-up_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m28.432 10.254 22.447.03L6.838 54.326l2.836 2.836 44.042-44.041.03 22.448 3.996.032V6.258H28.399z",
    clipRule: "evenodd"
  })));
};
export { SvgArrowDiagRightUp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTI4LjQzMTUgMTAuMjUzNkw1MC44NzkxIDEwLjI4NDRMNi44Mzc2NSA1NC4zMjU5TDkuNjc0MDkgNTcuMTYyNEw1My43MTU3IDEzLjEyMDlMNTMuNzQ2NSAzNS41Njg2TDU3Ljc0MiAzNS42MDA3VjYuMjU4MDZIMjguMzk5M0wyOC40MzE1IDEwLjI1MzZaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";